export default __webpack_public_path__ + "static/Verde-que-transborda-e3bd67bfc1059d87de8ecf60a39b6d07.jpg";